import type { IServices } from '../../../../models';
import { AppPricingPlans } from '../../../../services/apps-pricing-plans/app-pricing-plans';
import type { IAppsPricingPlans } from '../../../../services/apps-pricing-plans/types';

export async function getAppPricingPlans({
  services,
  appId,
}: {
  services: IServices;
  appId: string;
}): Promise<IAppsPricingPlans> {
  const [appsPlans, pricingModel] = await Promise.all([
    services.queryAppsPlans({
      appIds: [appId],
    }),
    services.getPricingModel({ appId }),
  ]);

  return new AppPricingPlans(
    appsPlans.findByAppId(appId),
    pricingModel,
  ).toJSON();
}
